import JraEncodeDecodeModule from './JraEncodeDecodeModule';

export default class JraChildren extends JraEncodeDecodeModule {
  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);

    this.element = element;
  }
}
